"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AffiliateProgramFeature = void 0;
var AffiliateProgramFeature;
(function (AffiliateProgramFeature) {
    AffiliateProgramFeature["Off"] = "off";
    AffiliateProgramFeature["RegisterWithCode"] = "register_with_code";
    AffiliateProgramFeature["RegistrationReward"] = "registration_reward";
    AffiliateProgramFeature["JoinTournament"] = "join_tournament";
    AffiliateProgramFeature["WithdrawTournament"] = "withdraw_tournament";
    AffiliateProgramFeature["OwnerView"] = "owner_view";
    AffiliateProgramFeature["CommissionPayout"] = "commission_payout";
    AffiliateProgramFeature["ShortUrl"] = "short_url";
})(AffiliateProgramFeature = exports.AffiliateProgramFeature || (exports.AffiliateProgramFeature = {}));
//# sourceMappingURL=affiliate-program-feature.js.map